import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { jwtDecode } from 'jwt-decode';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { OtpRequestPayload } from 'src/app/models/interface/Registration/registration';
import { OtpVerificationDialogComponent } from 'src/app/modules/cam/components/otp-verification-dialog/otp-verification-dialog.component';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { PsqServiceService } from 'src/app/services/commonService/psq-service.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ThankyouService } from 'src/app/shared/common/thankyou.service';
import { NgIf, NgFor } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DependentDatalayerService } from 'src/app/services/dataLayer/CAM/dependent.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { ContentService } from '../../services/content.service';

@Component({
    selector: 'app-change-email-domain',
    templateUrl: './change-email-domain.component.html',
    styleUrls: ['./change-email-domain.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, MatIcon, ReactiveFormsModule, CamEmptyStateComponent, MatFormField, MatInput, MatError, MatButton, NgFor, MatProgressSpinner]
})
export class ChangeEmailDomainComponent implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();
  /** Auto-dismiss for the inline mismatch toast on this screen only. */
  private static readonly MISMATCH_TOAST_MS = 5000;
  private static readonly MISMATCH_USERS_PAGE_SIZE = 20;
  private mismatchToastTimeoutId: ReturnType<typeof setTimeout> | null = null;
  @ViewChild('failedEmployeesTemplate') private failedEmployeesTemplate!: TemplateRef<any>;
  @ViewChild('contactSupportTemplate') private contactSupportTemplate!: TemplateRef<any>;
  @ViewChild('processingTemplate') private processingTemplate!: TemplateRef<any>;
  ModalRef!: MatDialogRef<OtpVerificationDialogComponent>;
  noDomainInfoModalRef!: MatDialogRef<TemplateRef<any>>;
  domainUpdateIncompleteModalRef!: MatDialogRef<TemplateRef<any>>;
  mismatchUsersModalRef!: MatDialogRef<TemplateRef<any>>;
  failedEmployeesModalRef!: MatDialogRef<TemplateRef<any>>;
  contactSupportModalRef!: MatDialogRef<TemplateRef<any>>;
  processingModalRef!: MatDialogRef<TemplateRef<any>>;
  failedEmployees: Array<{ contactId: string; ciamId: string; employeeEmail: string; isAdmin: boolean }> = [];
  domainUpdateRetryLoading = false;
  isDomainAcceptable = false;
  isDomainCheckLoading = false;
  private _retryAccountId = '';
  hasDomain: boolean = false;
  showNoDomainEditor: boolean = false;
  isDomainEditable: boolean = false;
  showMismatchBanner: boolean = false;
  mismatchedUsers: Array<{
    userFirstName?: string;
    userLastName?: string;
    employeeCode?: string;
    emailAddress?: string;
  }> = [];
  mismatchUsersPageNumber = 1;
  mismatchUsersHasNextPage = false;
  mismatchUsersLoading = false;
  private mismatchUsersDomain = '';
  private mismatchUsersB2BId = '';
  domainName: string = '';
  loginEmail: string = '';
  tokenData: any = null;
  phoneNumber: string = '';
  phoneExtension: string = '';
  form!: FormGroup;
  Loader: any = {
    isSpinner: false
  };
  content:any;
  dictionaryContent:any;
  private readonly destroy$ = new Subject<void>();
  manageTravelerContent:any;
  constructor(
    private _MatDialog: MatDialog,
    private _companyManagementService: CompanyManagementService,
    private fb: FormBuilder,
    private crypto: CryptoService,
    private _CamApiService: CamService,
    private _ToastrApiService: ToastrApiService,
    private readonly _psqService: PsqServiceService,
    private readonly _commonService: CommonService,
    private readonly _thankyouService: ThankyouService,
    private readonly _cdr: ChangeDetectorRef,
    private _DependentDatalayer:DependentDatalayerService,
    private readonly contentService:CompanyManagementContentService,
    private readonly dictionaryContentService:DisctionaryContent,
    private readonly manageTravelercontentService: ContentService
  ) { }

  ngOnDestroy(): void {
    this.clearMismatchToastTimer();
    this._destroy$.next();
    this._destroy$.complete();
  }

  private clearMismatchToastTimer(): void {
    if (this.mismatchToastTimeoutId != null) {
      clearTimeout(this.mismatchToastTimeoutId);
      this.mismatchToastTimeoutId = null;
    }
  }

  private scheduleMismatchToastDismiss(): void {
    this.clearMismatchToastTimer();
    this.mismatchToastTimeoutId = setTimeout(() => {
      this.mismatchToastTimeoutId = null;
      this.showMismatchBanner = false;
    }, ChangeEmailDomainComponent.MISMATCH_TOAST_MS);
  }

  dismissMismatchToast(): void {
    this.clearMismatchToastTimer();
    this.showMismatchBanner = false;
  }

   ngOnInit(): void {
     this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.dictionaryContent = res;
    });
    this.manageTravelercontentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
    this.manageTravelerContent = res;
  });

    const token = localStorage.getItem('QlAccessToken');
    const decoded: any = token ? jwtDecode(token) : null;
    this.tokenData = decoded;
    this.loginEmail = (this.crypto.getValueFromKey('LOGINNAME') as string | null)?.toLowerCase() || '';

    const rawHasDomain = decoded?.hasDomain;
    this.domainName = decoded?.domainName || decoded?.emailDomain || '';

    if (typeof rawHasDomain === 'boolean') {
      this.hasDomain = rawHasDomain;
    } else if (typeof rawHasDomain === 'string') {
      this.hasDomain = rawHasDomain.toLowerCase() === 'true';
    } else {
      this.hasDomain = !!this.domainName;
    }
    this.form = this.fb.group({
      domain: [
        this.domainName,
        [
          Validators.required,
          Validators.pattern(/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/) 
        ]
      ]
    });

    if (this.hasDomain) {
      this.form.get('domain')?.disable();
      this.isDomainEditable = false;
    } else {
      this.form.get('domain')?.disable();
      this.isDomainEditable = false;
    }

    const domainCtrl = this.form.get('domain')!;

    // Immediately invalidate acceptability whenever the value changes.
    domainCtrl.valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => { this.isDomainAcceptable = false; });

    // Debounced API check — only runs when the control is enabled, valid, and the user has typed.
    domainCtrl.valueChanges
      .pipe(debounceTime(500), takeUntil(this._destroy$))
      .subscribe((value) => {
        if (!domainCtrl.enabled || !domainCtrl.valid || !value?.trim() || !domainCtrl.dirty) return;
        this._checkDomainAvailability(value.trim().toLowerCase());
      });
  }


  async openModal() {
    // GTM service call
    this._companyManagementService.email_domain_edit('Edit');
    this._DependentDatalayer.changeDomain('Edit','Edit',1);
    this.Loader.isSpinner = true;

    try {
      if (!this.phoneNumber) {
        const guid =(this.crypto.getValueFromKey('USERGUID') as string) ||this.tokenData?.userGuid ||'';
        const subagentId =(this.crypto.getValueFromKey('SUBAGENTID') as string) ||this.tokenData?.subAgentId ||'';
        const userRole =(this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string) ||this.tokenData?.role ||'';
        const b2BUserId =(this.crypto.getValueFromKey('USERID') as string) ||this.tokenData?.userId ||'';

        const travelerRes: any = await this._CamApiService.PostUserExecutiveV1(guid, {
          subagentId,
          userRole,
          B2BUserId: b2BUserId
        });

        if (travelerRes?.status === 'Success') {
          const personalInfo = travelerRes?.data?.personalInfo || {};
          this.phoneNumber = personalInfo?.phoneNumber || '';
          this.phoneExtension = personalInfo?.phoneExtension || '';
        }
      }

      if (!this.phoneNumber) {
        this.Loader.isSpinner = false;
        this._ToastrApiService.show('error', 'Mobile number not found. Unable to send OTP.');
        return;
      }

      const mobile = (this.phoneNumber || '').replace(/[^+\d]/g, '');

      const otpPayload: OtpRequestPayload = {
        type: 'mobile',
        otpAction: 'mobileOrEmailValidation',
        value: this.phoneExtension + mobile,
        channel: 'mobile',
        companyId: 'SAA',
        b2BId: null,
        b2BUserId: null,
        eventName: 'UserDeactivate'
      };

      const res: any = await this._CamApiService.sendOTP(otpPayload);
      const checksum = res?.data?.checksum;
      this.Loader.isSpinner = false;

      this.ModalRef = this._MatDialog.open(OtpVerificationDialogComponent, {
        panelClass: ['custom-popup-gen-link-account-popup', 'otp-no-step-label'],
        data: {
          PhoneNumber: this.phoneNumber,
          isdCode: this.phoneExtension,
          verifyMode: 'mobile',
          showStepLabel: false,
          otpChecksum: checksum,
          companyChangeDomain:'isChangeDomain',
          onResend: async () => {
            try {
              const resendRes: any = await this._CamApiService.sendOTP({
                type: 'mobile',
                otpAction: 'mobileOrEmailValidation',
                value: this.phoneExtension + (this.phoneNumber || '').replace(/[^+\d]/g, ''),
                channel: 'mobile',
                companyId: 'SAA',
                b2BId: null,
                b2BUserId: null,
                eventName: 'UserDeactivate'
              });
              return { success: true, checksum: resendRes?.data?.checksum };
            } catch (err: any) {
              return { success: false, message: err?.error?.details?.[0]?.title || 'Failed to resend OTP.' };
            }
          },
          onVerify: async (otp: string, otpChecksum: string) => {
            try {
              const verifyRes: any = await this._CamApiService.VerifyOTP({
                otp,
                checksum: otpChecksum,
                type: 'mobile',
                value: this.phoneExtension + (this.phoneNumber || '').replace(/[^+\d]/g, ''),
                otpAction: 'mobileOrEmailValidation',
                channel: 'mobile',
                companyId: 'SAA',
                eventName: 'UserDeactivate',
                b2BId: null,
                b2BUserId: null
              });
              if (verifyRes?.data?.otpVerified === true) {
                return { success: true, message: 'OTP verified successfully.' };
              }
              const msg = verifyRes?.data?.message || verifyRes?.message || 'Invalid OTP. Please try again.';
              return { success: false, message: msg };
            } catch (err: any) {
              const msg = err?.error?.message || err?.error?.details?.[0]?.title || 'OTP verification failed.';
              return { success: false, message: msg };
            }
          }
        }
      });

      this.ModalRef.afterClosed().subscribe((result) => {
        if (result === 'verified' || result?.verified === true) {
          this.form.get('domain')?.enable();
          this.form.patchValue({ domain: '' });
          this.form.get('domain')?.markAsPristine();
          this.form.get('domain')?.markAsUntouched();
          this.form.get('domain')?.setErrors(null);
          this.isDomainEditable = true;
        }
      });
    } catch (error: any) {
      this.Loader.isSpinner = false;
      const apiErrorCode = error?.error?.details?.[0]?.code;
      if (apiErrorCode === 'DUPLICATE_ENTRY') {
        this._ToastrApiService.show(
          'error',
          'OTP already sent. Please wait 30 seconds before trying again.'
        );
      } else {
        this._ToastrApiService.show(
          'error',
          error?.error?.details?.[0]?.title || 'Failed to send OTP'
        );
      }
    }
  }

  onEmailDomainCancel(){
    // GTM service call
    this._companyManagementService.email_domain_click('Cancel');
    this._DependentDatalayer.changeDomain('Cancel','Cancel',0);
    this.isDomainAcceptable = false;
    this.isDomainCheckLoading = false;
    this.form.get('domain')?.setErrors(null);
    if (this.hasDomain) {
      this.form.patchValue({ domain: this.domainName });
      this.form.get('domain')?.disable();
      this.isDomainEditable = false;
    } else if (this.showNoDomainEditor) {
      this.form.patchValue({ domain: '' });
      this.form.get('domain')?.disable();
      this.showNoDomainEditor = false;
    }
  }

  private async _checkDomainAvailability(domain: string): Promise<void> {
    this.isDomainCheckLoading = true;
    const domainCtrl = this.form.get('domain')!;
    try {
      const res = await this._CamApiService.checkDuplicateDomain({ domainName: domain });
      // HTTP 200 → domain already exists → not acceptable
      this.isDomainAcceptable = false;
      domainCtrl.setErrors({ domainExists: res?.message || 'Domain already exists.' });
      domainCtrl.markAsTouched();
    } catch (error: any) {
      // HTTP 404 → domain not found → available → acceptable
      this.isDomainAcceptable = error?.status === 404;
    } finally {
      this.isDomainCheckLoading = false;
      this._cdr.detectChanges();
    }
  }

  onEmailDomainSave(){
    // GTM service call
    this._companyManagementService.email_domain_click('Save');
    
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    // GTM service call
    this._DependentDatalayer.changeDomain('Save','Save',1);
    if (this.hasDomain || this.showNoDomainEditor) {
      this.clearMismatchToastTimer();
      this.showMismatchBanner = false;
      this.updateCorporateDomainForUsers();
      return;
    }

    // GTM Success Event
    this._companyManagementService.email_domain_success('CTA Click','Domain_change_success');
      this._DependentDatalayer.changeDomainNoResult( 'updated successfully', 'Save' );

  }

  openNoDomainInfoPopup(template: TemplateRef<any>): void {
    this.noDomainInfoModalRef = this._MatDialog.open(template, {
      panelClass: 'custom-popup-gen-policy-filter-popup',
      disableClose: false,
      autoFocus: false
    });
  }

  closeNoDomainInfoPopup(): void {
    this.noDomainInfoModalRef?.close();
  }

  onNoDomainPopupContinue(): void {
    this.closeNoDomainInfoPopup();
    this.showNoDomainEditor = true;
    this.form.patchValue({ domain: '' });
    this.form.get('domain')?.enable();
    this.form.get('domain')?.markAsPristine();
    this.form.get('domain')?.markAsUntouched();
  }

  openDomainUpdateIncompletePopup(template: TemplateRef<any>): void {
    this.domainUpdateIncompleteModalRef = this._MatDialog.open(template, {
      panelClass: 'custom-popup-gen-policy-filter-popup',
      disableClose: false,
      autoFocus: false
    });
  }

  closeDomainUpdateIncompletePopup(): void {
    this.domainUpdateIncompleteModalRef?.close();
  }

  onMismatchViewClick(template: TemplateRef<any>): void {
    this.closeDomainUpdateIncompletePopup();
    this.mismatchUsersModalRef = this._MatDialog.open(template, {
      panelClass: 'custom-popup-gen-mismatch-users-list-dialog',
      disableClose: false,
      autoFocus: false
    });
  }

  getMismatchUserDisplayName(user: { userFirstName?: string; userLastName?: string }): string {
    const name = [user?.userFirstName, user?.userLastName].filter((p) => !!p && String(p).trim()).join(' ').trim();
    return name || '-';
  }

  closeMismatchUsersPopup(): void {
    this.mismatchUsersModalRef?.close();
  }

  onReadMoreClick(template: TemplateRef<any>): void {
    // Do not clear the auto-dismiss timer: clearing it left the banner visible indefinitely.
    this.openDomainUpdateIncompletePopup(template);
  }

  async onMismatchUsersNextPage(): Promise<void> {
    if (!this.mismatchUsersHasNextPage || this.mismatchUsersLoading) {
      return;
    }
    await this.loadMismatchUsersPage(this.mismatchUsersPageNumber + 1);
  }

  async onMismatchUsersPreviousPage(): Promise<void> {
    if (this.mismatchUsersPageNumber <= 1 || this.mismatchUsersLoading) {
      return;
    }
    await this.loadMismatchUsersPage(this.mismatchUsersPageNumber - 1);
  }

  private async loadMismatchUsersPage(pageNumber: number): Promise<void> {
    if (!this.mismatchUsersDomain || !this.mismatchUsersB2BId) {
      return;
    }
    this.mismatchUsersLoading = true;
    try {
      const res = await this._CamApiService.checkCorporateEmailDomain({
        b2BDomain: this.mismatchUsersDomain,
        B2BId: this.mismatchUsersB2BId,
        PageNumber: pageNumber,
        PageSize: ChangeEmailDomainComponent.MISMATCH_USERS_PAGE_SIZE
      });
      const users = res?.data?.users || [];
      if (res?.status === 'Success') {
        this.mismatchedUsers = users;
        this.mismatchUsersPageNumber = pageNumber;
        this.mismatchUsersHasNextPage = users.length === ChangeEmailDomainComponent.MISMATCH_USERS_PAGE_SIZE;
      } else {
        this._ToastrApiService.show('error', res?.message || 'Failed to fetch mismatch users.');
      }
    } catch (error: any) {
      this._ToastrApiService.show(
        'error',
        error?.error?.message || error?.error?.details?.[0]?.title || 'Failed to fetch mismatch users.'
      );
    } finally {
      this.mismatchUsersLoading = false;
    }
  }

  private async updateCorporateDomainForUsers(): Promise<void> {
    const nextDomain = (this.form.get('domain')?.value || '').trim().toLowerCase();
    const subAgentId = (this.crypto.getValueFromKey('SUBAGENTID') as string) || this.tokenData?.subAgentId || '';
    const userRole = (this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string) || this.tokenData?.role || '';
    const b2BUserId = (this.crypto.getValueFromKey('USERID') as string) || this.tokenData?.userId || '';
    const uid =this.tokenData?.uid ||this.tokenData?.UID ||sessionStorage.getItem('UID') ||localStorage.getItem('UID') ||'';
    const accountId = this.tokenData?.AccountId || '';

    if (!nextDomain || !subAgentId || !b2BUserId || !accountId) {
      this._ToastrApiService.show('error', 'Unable to update domain. Missing required user details.');
      return;
    }

    this.Loader.isSpinner = true;

    try {
      if (!this.hasDomain) {
        // First check for a pseudo-domain scenario (all travelers share the same domain)
        const managerRes = await this._CamApiService.getManagerList(subAgentId,uid,'',
          {
            subagentId: subAgentId,
            userRole,
            b2BUserId
          }
        );

        const managers = managerRes?.data?.managers || [];
        const validManagers = managers.filter((item: any) => item?.contactId);
        
        let isPseudoDomain = false;
        if (validManagers.length > 0) {
          const uniqueDomains = new Set(
            validManagers
              .map((item: any) => {
                const email = (item?.emailAddress || '').trim().toLowerCase();
                return email.includes('@') ? email.split('@')[1] : '';
              })
              .filter((d: string) => !!d)
          );
          isPseudoDomain = uniqueDomains.size === 1;
        }

        if (isPseudoDomain) {
          this.openProcessingPopup();
          const employeeData = validManagers
            .map((item: any) => {
              const oldEmail = (item?.emailAddress || '').trim().toLowerCase();
              const emailPrefix = oldEmail.includes('@') ? oldEmail.split('@')[0] : oldEmail;
              return {
                contactId: item.contactId,
                ciamId: item.ciamId || '',
                employeeEmail: `${emailPrefix}@${nextDomain}`,
                isAdmin: item?.isCorpTravelArranger === '0'
              };
            });

          const updateRes = await this._CamApiService.updateCorporateDomain({ accountId, employeeData });

          const hasFailedChunks = Array.isArray(updateRes?.FailedChunks) && updateRes.FailedChunks.length > 0;

          if (updateRes?.StatusCode !== 200 || hasFailedChunks) {
            this.Loader.isSpinner = false;
            this.closeProcessingPopup();
            if (hasFailedChunks) {
              this.failedEmployees = updateRes.FailedChunks.flatMap((chunk: any) => chunk?.Employees || []);
              this._retryAccountId = accountId;
              this.openFailedEmployeesPopup();
            } else {
              this._ToastrApiService.show('error', updateRes?.Message || 'Failed to update corporate domain.');
            }
            return;
          }

          // GTM Success Event
          this._companyManagementService.email_domain_success('CTA Click','Domain_change_success');
          this._DependentDatalayer.changeDomainNoResult( 'updated successfully', 'Save' );
          this.clearMismatchToastTimer();
          this.performLogout();
          return;
        }

        // If not a pseudo domain, fall back to existing mismatch checks
        const checkRes = await this._CamApiService.checkCorporateEmailDomain({
          b2BDomain: nextDomain,
          B2BId: subAgentId,
          PageNumber: 1,
          PageSize: ChangeEmailDomainComponent.MISMATCH_USERS_PAGE_SIZE
        });

        const users = checkRes?.data?.users || [];
        const isAllUsersMatching = checkRes?.status === 'Success' && Array.isArray(users) && users.length === 0;

        if (!isAllUsersMatching) {
          this.Loader.isSpinner = false;
          if (checkRes?.status === 'Success' && users?.length > 0) {
            this.mismatchUsersDomain = nextDomain;
            this.mismatchUsersB2BId = subAgentId;
            this.mismatchUsersPageNumber = 1;
            this.mismatchUsersHasNextPage =
              users.length === ChangeEmailDomainComponent.MISMATCH_USERS_PAGE_SIZE;
            this.mismatchedUsers = users;
            this.showMismatchBanner = true;
            this.scheduleMismatchToastDismiss();
          } else {
            this._ToastrApiService.show('error', checkRes?.message || 'Domain check failed.');
          }
          return;
        }

        const parsedB2BId = Number(subAgentId);
        if (!Number.isFinite(parsedB2BId)) {
          this.Loader.isSpinner = false;
          this._ToastrApiService.show('error', 'Failed to update domain. Invalid B2B ID.');
          return;
        }

        const domainUpdateRes = await this._CamApiService.updateCorporateDomainV1({
          b2BId: parsedB2BId,
          b2BDomain: nextDomain
        });

        if (domainUpdateRes?.status !== 'Success') {
          this.Loader.isSpinner = false;
          this._ToastrApiService.show('error', domainUpdateRes?.message || 'Failed to update domain.');
          return;
        }

        this.Loader.isSpinner = false;
        this._psqService.clearStoredData();
        this._commonService.triggerLogoutTab();
        this._thankyouService.show({
          heading: "You've been logged out!",
          buttonText: 'Go to Login',
          redirectUrl: '',
          isShowButton: true
        });
        return;
      }

      this.openProcessingPopup();

      const managerRes = await this._CamApiService.getManagerList(subAgentId,uid,'',
        {
          subagentId: subAgentId,
          userRole,
          b2BUserId
        }
      );

      const managers = managerRes?.data?.managers || [];
      if (!managers.length) {
        this.Loader.isSpinner = false;
        this.closeProcessingPopup();
        this._ToastrApiService.show('error', 'No travelers found for domain update.');
        return;
      }

      const employeeData = managers
        .filter((item: any) => item?.contactId)
        .map((item: any) => {
          const oldEmail = (item?.emailAddress || '').trim().toLowerCase();
          const emailPrefix = oldEmail.includes('@') ? oldEmail.split('@')[0] : oldEmail;
          return {
            contactId: item.contactId,
            ciamId: item.ciamId || '',
            employeeEmail: `${emailPrefix}@${nextDomain}`,
            isAdmin: item?.isCorpTravelArranger === '0'
          };
        });

      if (!employeeData.length) {
        this.Loader.isSpinner = false;
        this.closeProcessingPopup();
        this._ToastrApiService.show('error', 'No valid traveler data found for domain update.');
        return;
      }

      const updateRes = await this._CamApiService.updateCorporateDomain({ accountId, employeeData });

      const hasFailedChunks = Array.isArray(updateRes?.FailedChunks) && updateRes.FailedChunks.length > 0;

      if (updateRes?.StatusCode !== 200 || hasFailedChunks) {
        this.Loader.isSpinner = false;
        this.closeProcessingPopup();
        if (hasFailedChunks) {
          this.failedEmployees = updateRes.FailedChunks.flatMap((chunk: any) => chunk?.Employees || []);
          this._retryAccountId = accountId;
          this.openFailedEmployeesPopup();
        } else {
          this._ToastrApiService.show('error', updateRes?.Message || 'Failed to update corporate domain.');
        }
        return;
      }

      // GTM Success Event
      this._companyManagementService.email_domain_success('CTA Click','Domain_change_success');
      this._DependentDatalayer.changeDomainNoResult( 'updated successfully', 'Save' );
      this.clearMismatchToastTimer();
      this.performLogout();
      return;
    } catch (error: any) {
      this.Loader.isSpinner = false;
      this.closeProcessingPopup();
      const errorBody = error?.error;
      const hasFailedChunks = Array.isArray(errorBody?.FailedChunks) && errorBody.FailedChunks.length > 0;
      if (hasFailedChunks) {
        this.failedEmployees = errorBody.FailedChunks.flatMap((chunk: any) => chunk?.Employees || []);
        this._retryAccountId = accountId;
        this.openFailedEmployeesPopup();
      } else {
        this._ToastrApiService.show(
          'error',
          errorBody?.Message || errorBody?.message || errorBody?.details?.[0]?.title || 'Failed to update corporate domain.'
        );
      }
    }
  }

  private openProcessingPopup(): void {
    this.processingModalRef = this._MatDialog.open(this.processingTemplate, {
      panelClass: 'custom-popup-gen-processing-popup',
      disableClose: true,
      autoFocus: false
    });
  }

  private closeProcessingPopup(): void {
    this.processingModalRef?.close();
  }

  private openFailedEmployeesPopup(): void {
    this.failedEmployeesModalRef = this._MatDialog.open(this.failedEmployeesTemplate, {
      panelClass: 'custom-popup-gen-failed-employees-dialog',
      disableClose: true,
      autoFocus: false
    });
  }

  closeFailedEmployeesPopup(): void {
    this.failedEmployeesModalRef?.close();
  }

  private openContactSupportPopup(): void {
    this.contactSupportModalRef = this._MatDialog.open(this.contactSupportTemplate, {
      panelClass: 'custom-popup-gen-policy-filter-popup',
      disableClose: false,
      autoFocus: false
    });
  }

  closeContactSupportPopup(): void {
    this.contactSupportModalRef?.close();
  }

  async onDomainUpdateRetry(): Promise<void> {
    if (this.domainUpdateRetryLoading) return;
    this.domainUpdateRetryLoading = true;
    try {
      const retryRes = await this._CamApiService.retryDomainUpdate();

      if (retryRes?.StatusCode === 200) {
        this.failedEmployeesModalRef?.close();
        this.performLogout();
      } else {
        this.domainUpdateRetryLoading = false;
        this.failedEmployeesModalRef?.close();
        this.openContactSupportPopup();
      }
    } catch (error: any) {
      this.domainUpdateRetryLoading = false;
      this.failedEmployeesModalRef?.close();
      this.openContactSupportPopup();
    }
  }

  private performLogout(): void {
    this.Loader.isSpinner = false;
    this.domainUpdateRetryLoading = false;
    this.closeProcessingPopup();
    this._psqService.clearStoredData();
    this._commonService.triggerLogoutTab();
    this._thankyouService.show({
      heading: "You've been logged out!",
      buttonText: 'Go to Login',
      redirectUrl: '',
      isShowButton: true
    });
  }

  sitecoreGetWarningMessage(messageId: string): any {
    return this.content?.warningList?.find(
      (item: any) => item.messageID === messageId
    );
  }

}
